import { Button } from '@spotnana/blocks/src/Button/Button';
import { Typography } from '@spotnana/blocks/src/Typography/Typography';

interface CardDetailActionProps {
  children: string;
  onClickAction?: () => void;
}

const CardDetailAction = ({ onClickAction, children }: CardDetailActionProps): JSX.Element => (
  <Button variant="ghost" onClick={onClickAction} data-testid="view-map-button" size="small" aria-haspopup="dialog">
    <Typography variant="body3" kind="semibold" color="link">
      {children}
    </Typography>
  </Button>
);

export default CardDetailAction;
